module.exports = __webpack_public_path__ + "static/media/photo_selfie.c100ad1c.png";